import { MAX_LOCATION_RADIUS_MILES, MIN_LOCATION_RADIUS_MILES } from "../constants/search";

export const hasTextSearchValue = (value) => typeof value === "string" && value.trim().length > 0;

const toFiniteNumber = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === "string" && value.trim() === "") {
    return null;
  }
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const normalizeLocationRadiusFilter = (filters) => {
  if (!filters || typeof filters !== "object") {
    return null;
  }

  const latitude = toFiniteNumber(filters.locationLatitude);
  const longitude = toFiniteNumber(filters.locationLongitude);
  const radiusMiles = toFiniteNumber(filters.locationRadiusMiles);

  if (
    latitude === null
    || longitude === null
    || radiusMiles === null
    || latitude < -90
    || latitude > 90
    || longitude < -180
    || longitude > 180
    || radiusMiles < MIN_LOCATION_RADIUS_MILES
    || radiusMiles > MAX_LOCATION_RADIUS_MILES
  ) {
    return null;
  }

  return {
    latitude,
    longitude,
    radiusMiles,
  };
};

export const hasActiveUserSearchFilters = (filters) => {
  if (!filters || typeof filters !== "object") {
    return false;
  }

  if (
    hasTextSearchValue(filters.location)
    || hasTextSearchValue(filters.preferredStyle)
    || hasTextSearchValue(filters.commitment)
  ) {
    return true;
  }

  if (normalizeLocationRadiusFilter(filters)) {
    return true;
  }

  if (Array.isArray(filters.preferredStyles) && filters.preferredStyles.some(hasTextSearchValue)) {
    return true;
  }

  if (Array.isArray(filters.instrumentExperience)) {
    return filters.instrumentExperience.some(
      (exp) => hasTextSearchValue(exp?.instrument)
    );
  }

  return false;
};

export default hasActiveUserSearchFilters;
